import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const updateProfile = createAsyncThunk(
  "api/fetchData",
  async ({ userData, uid }) => {
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/user/` + uid,

        userData,
        config
      );
      let status = "success";
      let data_res = {
        status: status,
        message: response?.data,
      };
      return data_res;
    } catch (error) {
      let status = "error";
      let data_error = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data_error;
    }
  }
);

const updateProfileSlice = createSlice({
  name: "api",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateProfileSlice.reducer;
